import { StateEnum } from "../../../Models/Bases/StateEnum";
import { BaseService } from "../../Bases/BaseService";
import { ValidationResponse } from "../../Bases/ValidationResponse";

export class ConeLogisticoFiltroAcessoService extends BaseService {
    public selecionarValidos(coneFiltroAcessos: any) {
        return coneFiltroAcessos?.filter((e: any) => e.state != StateEnum.Deleted) ?? [];
    }

    public salvar(coneFiltroAcesso: any, coneFiltroAcessos: any)
    {
        if (!(coneFiltroAcesso.regional) &&
            !this.numberIsFilled(coneFiltroAcesso.operacao_id) &&
            !this.numberIsFilled(coneFiltroAcesso.destino_id) &&
            !this.numberIsFilled(coneFiltroAcesso.origem_id))
        {
            return new ValidationResponse(null, 'Preencha ao menos um dos campos solicitados!');
        }

        let validation = coneFiltroAcessos?.filter(
            (e: any) =>
                coneFiltroAcesso.id != e.id &&
                coneFiltroAcesso.regional == e.regional &&
                coneFiltroAcesso.origem_id == e.origem_id &&
                coneFiltroAcesso.destino_id == e.destino_id &&
                coneFiltroAcesso.operacao_id == e.operacao_id &&
                e.state != StateEnum.Deleted);

        if (validation.length > 0) {
            return new ValidationResponse(null, 'Filtro já inserido!');
        }

        if (coneFiltroAcesso.id == null || coneFiltroAcesso.id == 0)
        {
            let ids = coneFiltroAcessos?.map((x: any) => x.id) ?? [];
            let min = Math.min.apply(null, ids);
            coneFiltroAcesso.id = min > 0 ? -1 : min - 1; //isNaN(min) || 
            coneFiltroAcesso.state = StateEnum.Inserted;
            coneFiltroAcessos = coneFiltroAcessos.concat(coneFiltroAcesso);
        }
        else {
            coneFiltroAcesso.state = coneFiltroAcesso.state == StateEnum.Inserted ? StateEnum.Inserted : StateEnum.Updated;
            var index = coneFiltroAcessos.map(function(x:any) {return x.id; }).indexOf(coneFiltroAcesso.id);
            coneFiltroAcessos[index] = coneFiltroAcesso;
        }

        return new ValidationResponse(coneFiltroAcessos);
    }

    public apagar(id: number, coneFiltroAcessos: any) {
        if (id > 0) {
            coneFiltroAcessos.forEach((e: any) => e.state = (e.id == id ? StateEnum.Deleted : e.state));
        }
        else {
            coneFiltroAcessos = coneFiltroAcessos?.filter((e: any) => e.id != id);
        }

        return new ValidationResponse(coneFiltroAcessos);
    }
}